import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-ag-select-action-cell-renderer',
  templateUrl: './ag-select-action-cell-renderer.component.html',
  styleUrls: ['./ag-select-action-cell-renderer.component.css']
})
export class AgSelectActionCellRendererComponent implements OnInit, ICellRendererAngularComp {
  public params: any;
  constructor() { }
  public ngOnInit(): void {
  }

  public agInit(params: any): void {
    this.params = params;
  }

  public refresh(): boolean {
    return false;
  }

  public onSelect(): void {
   // this.params.context.componentParent.onSelect(this.params.data);
    console.log('params', this.params.data);
  }

}
